import {createContext} from 'react';
/* eslint-enable */
export const SpinnerContext = createContext(null)


